import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=ca2ab926&scoped=true"
import script from "./compare.vue?vue&type=script&lang=js"
export * from "./compare.vue?vue&type=script&lang=js"
import style0 from "./compare.vue?vue&type=style&index=0&id=ca2ab926&prod&lang=css"
import style1 from "./compare.vue?vue&type=style&index=1&id=ca2ab926&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2ab926",
  null
  
)

export default component.exports